// extracted by mini-css-extract-plugin
module.exports = {"privateMessageImage":"PrivateMessageSection_privateMessageImage__2U2Wf","closeDiv":"PrivateMessageSection_closeDiv__3yrgW"};